export default "__VITE_PUBLIC_ASSET__0f443e4f__"